<template>
  <div class="user-linker-container" v-if="isVisible">
    <b-button
      class="user-linker-search-button"
      @click="state.isSearching = true"
      v-if="!state.isSearching"
      ><b-icon-plus-circle-fill></b-icon-plus-circle-fill>
      {{ relationship }}</b-button
    >
    <div class="user-linker-search-container" v-else>
      <multi-select
        :disabled="state.isAdding"
        ref="select"
        v-model="selected"
        :loading="state.isRunningQuery"
        :multiple="multiple"
        :internal-search="false"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="false"
        :options="options"
        :placeholder="`${relationship} search`"
        :custom-label="userLabel"
        track-by="email"
        :preselect-first="false"
        :no-options="noOptions"
        @search-change="runSearch"
        ><template slot="noOptions">
          begin typing
        </template>
        <template slot="noResult">
          no users match this search
        </template>
      </multi-select>
      <b-button
        class="user-linker-add-button red"
        variant="primary"
        :disabled="
          null === selected ||
            (Array.isArray(selected) && 0 === selected.length) ||
            state.isAdding
        "
        @click="emitAddEvent"
        >add {{ relationship }}</b-button
      >
      <b-button
        @click="cancelSearch"
        :disabled="state.isAdding"
        class="user-linker-cancel-button red"
        variant="primary"
        >cancel</b-button
      >
    </div>
  </div>
</template>

<script>
import MultiSelect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { BButton, BIconPlusCircleFill } from "bootstrap-vue";
import MentorApplicationApi from "../lib/MentorApplicationApi";
import { EmitUp } from "../lib/VueHelpers";
export const AddUserLinkEvent = "add-user-link";

export default {
  name: "UserLinker",
  data() {
    return {
      mostRecentQuery: "",
      state: {
        isSearching: false,
        isRunningQuery: false,
        isAdding: false
      },
      noOptions: "begin typing",
      selected: null,
      mentorApplicationApi: new MentorApplicationApi(this.apiRootUrl),
      options: []
    };
  },
  methods: {
    emitAddEvent() {
      let that = this;
      this.state.isAdding = true;
      EmitUp(
        AddUserLinkEvent,
        {
          user: this.selected,
          relationship: this.relationship,
          handledCallback: (clear = false) => {
            that.state.isAdding = false;
            if (true === clear) {
              this.cancelSearch();
            }
          }
        },
        this
      );
    },
    cancelSearch() {
      this.selected = null;
      this.state.isSearching = false;
    },
    userLabel(user) {
      return `${user.firstName} ${user.lastName} (${user.email})`;
    },
    runSearch(value) {
      // TODO add cancellation https://github.com/axios/axios#cancellation
      this.mostRecentQuery = value;
      let roles = [this.relationship],
        that = this;
      this.state.isRunningQuery = true;
      this.mentorApplicationApi
        .userSearch(value, roles)
        .then(result => {
          if (value === that.mostRecentQuery) {
            that.options = result.data;
            that.state.isRunningQuery = false;
          }
        })
        .catch(() => {
          alert("Server error - user search failed");
          that.state.isRunningQuery = true;
        });
    }
  },
  props: {
    relationship: String,
    apiRootUrl: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    isVisible: { type: Boolean, default: true }
  },
  components: {
    MultiSelect,
    BButton,
    BIconPlusCircleFill
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.user-linker-search-button,
.user-linker-search-container,
.user-linker-add-button,
.user-linker-cancel-button {
  margin: 1rem 0;
}
.user-linker-cancel-button {
  margin-left: 1rem;
}
</style>
